<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar  toggleable="lg" type="light" variant="mdh">
          <b-navbar-brand href="/home">
            <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" style="color:#000 !important; background-color: #fff !important; opacity: 1.0 !important;"   >
              <b-icon icon="list" ></b-icon>
          </b-navbar-toggle>
          <!-- hamburger menu abpve-->


          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item-dropdown text="Admin"
                v-if="authenticated && hasRole('fhv-admin', 'fhv-admin-app')">
                <b-dropdown-item href="/settings">Application Settings</b-dropdown-item>
                <b-dropdown-item href="/grantees">Grantees</b-dropdown-item>
                <b-dropdown-item href="/grants">Grants</b-dropdown-item>
                <b-dropdown-item href="/providers">Providers</b-dropdown-item>
                <b-dropdown-item href="/redcap">REDCap Submitters</b-dropdown-item>
                <b-dropdown-item href="/accessqueue">Request Access List </b-dropdown-item>
                <b-dropdown-item href="/users">User Management </b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item href="/search" v-if="authenticated">Person Search</b-nav-item>
              <b-nav-item href="/requestaccess">Request Access</b-nav-item>
              
               <b-nav-item @click="logout" v-if="authenticated">Log out</b-nav-item>
               <b-nav-item @click="login" v-if="!authenticated">Log in</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>

    <main id="main-content">
      <b-container fluid style="max-width:95%;">
              <router-view/>
      </b-container>
    </main>
	
	<div>
		<div class="fluid-container footer">
			<p class="text-center">For questions, please email <a style="color:white;" href="mailto:health.FHVData@state.mn.us">health.FHVData@state.mn.us</a>  - v{{appVersion}}{{environment === 'prod' ? '' : '-'+environment.toUpperCase()}}</p>
		</div>
	</div>
  </div>
</template>

<script>
  import LocalStorageService from '@/common/LocalStorageService';
  import {version} from '../package.json';

  export default {
    data: () => ({
      environment: null
    }),
    created() {
      this.environment = `${process.env.VUE_APP_MODE}`
    },
    computed: {
      authenticated: function () {
        if (this.$keycloak) {
          return this.$keycloak.authenticated;
        } else {
          return false;
        }
      },
      appVersion: function () {
        return version;
      }
    },


    methods: {
      login() {
        const localStorageService = LocalStorageService.getService();
        localStorageService.clearAuthTokens();
        const loginUrl = this.$keycloak.createLoginUrl()
        window.location.replace(loginUrl)
      },
      logout() {
        const localStorageService = LocalStorageService.getService();
        localStorageService.clearAuthTokens();
        this.$keycloak.clearToken();
        this.$keycloak.logoutFn();
      },
      hasRole(roles) {
        if (this.$keycloak) {
          return this.$keycloak.hasResourceRole(roles);
        } else {
          return false;
        }
      }
    }
  }
</script>

<style lang="scss">

  @import "assets/_custom.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav  a.dropdown-item {
  color: black !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.colWidth40 {
  width: 40%;
}

.fluid-container.footer{
  background: rgb(0, 56, 101);
  font-weight: normal;
  color: white;
  margin-top:50px;
  min-height: 30px;
  display: block;
  vertical-align: middle;
  padding-top: 3px;
}
.fluid-container.footer > *:last-child {
    margin-bottom: 0px;
    color: #fff;
}

.search-label {
    display: inline-block;
    font-weight: bold;
    margin-right: 6px;
    margin-left: 6px;
}

</style>
